import { SHOP_TYPES } from '../../constants/shop';

export const upperFirstLetter = (str) => str?.[0]?.toUpperCase() + str?.slice(1);
export const lowerFirstLetter = (str) => str?.[0]?.toLowerCase() + str?.slice(1);

export const calculatePercentageTime = (time) => {
  const currentTime = time / 1000;
  const necessarySeconds = 3600;
  const percentage = 100 * (1 - currentTime / necessarySeconds);

  return Math.round(percentage * 100) / 100;
};

export const fromTimeStampFull = (timestamp, isArabic = false) => {
  const date = new Date(timestamp * 1000);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return isArabic ? `${year}/${month}/${day}` : `${day}.${month}.${year}`;
};

export const dateFromNow = (remainingSeconds, isArabic = false) => {
  if (!remainingSeconds) return '';

  const now = new Date();
  const futureDate = new Date(now.getTime() + remainingSeconds * 1000);
  const day = futureDate.getDate().toString().padStart(2, '0');
  const month = (futureDate.getMonth() + 1).toString().padStart(2, '0');

  return isArabic ? `${month}/${day}` : `${day}.${month}`;
};

export const getNecessaryTimeFormat = (date, isArabic = false) => {
  const dateObj = new Date(date * 1000);
  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');

  return isArabic ? `${month}/${day}` : `${day}.${month}`;
};

/**
 * Преобразует формат даты из DD.MM в MM/DD для арабского языка (RTL)
 * @param {string} dateStr - строка с датами в формате DD.MM (например, "27.10 - 02.11")
 * @param {string} language - текущий язык приложения
 * @returns {string} - строка с датами в формате MM.DD для арабского или исходный формат для других языков
 */
export const convertDateFormat = (dateStr, language) => {
  if (!dateStr) return dateStr;

  // Только для арабского (RTL) конвертируем в MM/DD
  const isArabic = language === 'ar';

  return isArabic ? dateStr.replace(/(\d{2})\.(\d{2})/g, '$2/$1') : dateStr;
};

export const randomChoice = (first, second) => (Math.random() < 0.5 ? first : second);

export const getTypeBySlotType = (type) => {
  return Object.entries(SHOP_TYPES).find(([, arr]) => arr.includes(type))?.[0] ?? null;
};

export const secondsToDays = (seconds, t) => {
  const days = seconds / 60 / 60 / 24;
  return {
    remainder: Math.ceil(days >= 1 ? days : days * 24),
    wordArray:
      days >= 1
        ? [t('other.days.0.text'), t('other.days.1.text'), t('other.days.2.text')]
        : [t('other.hours.0.text'), t('other.hours.1.text'), t('other.hours.2.text')],
  };
};

export const getCurrentMonthLastDay = () => {
  const todayDate = new Date();
  const newDate = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);
  const day = newDate.getDate().toString().padStart(2, '0');
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0');
  return `${day}.${month}`;
};

export const getDaysDeclension = (days) => {
  const n = Math.floor(Math.abs(days)) % 100;
  const last = n % 10;

  if (n > 10 && n < 20) return 'other.days.2.text';
  if (last > 1 && last < 5) return 'other.days.1.text';
  if (last === 1) return 'other.days.0.text';

  return 'other.days.2.text';
};

export const getHoursDeclension = (hours) => {
  const n = Math.floor(Math.abs(hours)) % 100;
  const last = n % 10;

  if (n > 10 && n < 20) return 'other.hours.2.text';
  if (last > 1 && last < 5) return 'other.hours.1.text';
  if (last === 1) return 'other.hours.0.text';

  return 'other.hours.2.text';
};

export const getMinutesDeclension = (minutes) => {
  const n = Math.floor(Math.abs(minutes)) % 100;
  const last = n % 10;

  if (n > 10 && n < 20) return 'other.minutes.2.text';
  if (last > 1 && last < 5) return 'other.minutes.1.text';
  if (last === 1) return 'other.minutes.0.text';

  return 'other.minutes.2.text';
};
